import * as React from 'react';
import './FingeringIndicator.css';
const FingeringText = (props) => {
    return (React.createElement("div", { className: props.standAlone ?
            'fingering-container'
            :
                'bigram-container' }, props.fingeringObject.fingering.map((finger, index) => (renderFingeredText(finger, index)))));
};
const getFingerNumber = function (fingering) {
    if (Array.isArray(fingering)) {
        return fingering[1];
    }
    else {
        return fingering.fingering[1];
    }
};
const renderFingeredText = function (text, index) {
    if (Array.isArray(text)) {
        return (React.createElement("span", { key: index, className: 'bigram b' + getFingerNumber(text) }, text[0] === ' ' ?
            '␣'
            :
                text[0]));
    }
    else {
        return renderModGroup(text, index);
    }
};
const renderModGroup = function (modGroup, index) {
    return (React.createElement("span", { key: index },
        React.createElement("span", { className: 'mod mod-start b' + modGroup.modFinger },
            modGroup.modName,
            "\u00A0"),
        modGroup.fingering.map((finger, index) => (React.createElement("span", { key: index, className: 'bigram b' + getFingerNumber(finger) }, finger[0]))),
        React.createElement("span", { className: 'mod mod-end b' + modGroup.modFinger })));
};
export default FingeringText;
//# sourceMappingURL=FingeringText.js.map